import Vue from 'vue'
import App from './App'
import Vant,{Lazyload} from 'vant'
import 'vant/lib/index.css'
import router from './route'
import wx from 'weixin-js-sdk'
import VueTouch from 'vue-touch';


Vue.use(Vant)
Vue.use(VueTouch)
Vue.use(require('vue-cookies'))
Vue.use(Lazyload)
new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
